import secureLocalStorage from "react-secure-storage";

export const checkAuth = () => {
    const accessToken = secureLocalStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + accessToken);
  myHeaders.append("Accept", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  fetch(
    "https://alhikmahinternational.org/al-asab/public/api/projects",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {

      if (result.message == "Unauthenticated.") {
        console.log('done')
        secureLocalStorage.setItem("authModal", true);
      }else{
        secureLocalStorage.setItem("authModal", false);

      }
    })
    .catch((error) => {
      console.log("error", error);
    });
};
